import { useState, type ReactElement } from "react";
import { FeatureErrorBoundary, Box, Text, Button } from "@citibox-panel/ui";

// Throws on render — only mounted once the user opts into the error in the demo
// below, so the showcase's default render stays clean (no caught error on load).
function BoomForDemo(): ReactElement {
  throw new Error("demo: fallo de una sección");
}

// Interactive demo: the boundary renders normal content until the user forces an
// error, then shows its alert fallback with a "Reintentar" that recovers.
export function ErrorBoundaryDemo(): ReactElement {
  const [broken, setBroken] = useState(false);
  return (
    <>
      <Text variant="body2" color="secondary" gutterBottom>
        Aísla el fallo de una sección: si un hijo lanza, muestra una alerta con
        opción de reintentar en lugar de tumbar el resto.
      </Text>
      <Box sx={{ maxWidth: 480 }}>
        <FeatureErrorBoundary
          fallbackTitle="No se pudo cargar esta sección."
          onReset={() => {
            setBroken(false);
          }}
        >
          {broken ? (
            <BoomForDemo />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1.5,
                alignItems: "flex-start",
              }}
            >
              <Text variant="body2">Contenido de la sección (sin errores).</Text>
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setBroken(true);
                }}
              >
                Forzar error
              </Button>
            </Box>
          )}
        </FeatureErrorBoundary>
      </Box>
    </>
  );
}
